import { concat, of, throwError } from 'rxjs';
import { mergeMap, take, map, takeUntil, catchError } from 'rxjs/operators';
import { IEpic, isTypeOf, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { interpolateErrorParams } from '@cbridge-utils/formatters';
import { SymbolGroupsAction } from '@cbridge-packages/symbol-groups';
import { SymbolSyntheticAction } from '@cbridge-packages/symbol-synthetic';
import { InfinityDataGridAction } from '@cbridge-modules/infinity-data-grid';

export const reloadSyntheticSymbolListEpic: IEpic = (action$) =>
  action$.pipe(
    isTypeOf(
      SymbolSyntheticAction.reload,
      SymbolSyntheticAction.create.done,
      SymbolSyntheticAction.update.done,
      SymbolSyntheticAction.remove.done,
    ),
    mergeMap(() => {
      const waitGroups$ = action$.pipe(
        isTypeOfAndGetPayload(SymbolGroupsAction.load.done),
        take(1),
        takeUntil(
          action$.pipe(
            isTypeOfAndGetPayload(SymbolGroupsAction.load.failed),
            mergeMap(({ error }) => throwError(() => new Error(`${error.errorCode} - ${interpolateErrorParams(error.description ?? '', error.params)}`))),
          ),
        ),
      );

      return concat(
        of(SymbolGroupsAction.load.started()),
        waitGroups$.pipe(
          map(() => {
            return InfinityDataGridAction.refreshData();
          }),
          catchError(() => of({ type: '@@CBRIDGE/NOOP' })), // safe action type
        ),
      );
    }),
  );
